module.exports = __webpack_public_path__ + "img/patrick-mouth-chomp.cce02ef2.png";